export default __webpack_public_path__ + "static/media/background.6cefd4ae.jpg";